import { chakra } from '@chakra-ui/react';
var CheckboxControl = chakra('span', {
  baseStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'top',
    userSelect: 'none',
    flexShrink: 0
  }
});
export { CheckboxControl };